module.exports = __webpack_public_path__ + "images/royal-canin.sprite--iconography--xs.382af21ccdb86ee3799309cb729970d3.svg";